/**
 * The mic and camera a roster row shows for a remote participant.
 *
 * Two different facts were being read as one. What the participant has ON is
 * theirs to report, and they do (`media:mic_*` / `media:camera_*`, kept in
 * Presence). What this viewer is RECEIVING from them is another matter: a
 * camera whose tile is off-screen is paused for this viewer, a bandwidth dip
 * starves it, a reconnect leaves no consumer for a few seconds — and reading
 * the Participants panel off received media showed each of those as "muted,
 * camera off" for someone whose mic and camera were both on.
 *
 * So the report wins when there is one. Received state is the fallback, for
 * peers whose client does not report (gateways, older clients).
 */
export function rosterMedia(
  reported: { micOn: boolean; camOn: boolean } | null | undefined,
  received: { muted: boolean; videoOn: boolean },
): { muted: boolean; cameraOn: boolean } {
  return reported
    ? { muted: !reported.micOn, cameraOn: reported.camOn }
    : { muted: received.muted, cameraOn: received.videoOn }
}
